import { render, staticRenderFns } from "./CookiesPolicyView.vue?vue&type=template&id=6357b27f&scoped=true&style=background-color%3A%20transparent%3B%20position%3Arelative%3B"
import script from "./CookiesPolicyView.vue?vue&type=script&lang=js"
export * from "./CookiesPolicyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6357b27f",
  null
  
)

export default component.exports